<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form">
      <el-form-item prop="email" :label="$t('authPage.emailLabel')">
        <el-input
          class="input"
          v-model="form.email"
          data-test="email-input"
          :placeholder="$t('authPage.emailLabel')">
        </el-input>
      </el-form-item>
      <el-form-item prop="mot de passe" :label="$t('loginPage.passwordLabel')">
        <el-input
          class="input"
          v-model="form.pwd"
          data-test="pwd-input"
          :placeholder="$t('loginPage.passwordLabel')"
          show-password>
        </el-input>
      </el-form-item>
      <el-button
        v-loading="loading"
        data-test="submit-button"
        type="success" style="width: 100%;"
        @click="submit">
        {{ $t('authPage.submitButtonText') }}
      </el-button>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        rules: {
          email: [
            {
              required: true,
              message: this.$t('commons.defaultErrorMessage'),
              trigger: 'blur',
            },
          ],
          pwd: [
            {
              required: true,
              message: this.$t('commons.defaultErrorMessage'),
              trigger: 'blur',
            },
          ],
        },
        form: {
          email: '',
          pwd: '',
        },
      };
    },
    methods: {
      submit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.ADAuth(this.form);
          }
        });
      },
      async ADAuth(cred) {
        this.loading = true;
        this.$emit('loginAttempt', cred);
      },
    },
  };
</script>

<style lang="stylus">
  .input {
    width 350px
  }
</style>
